import React, { useState, useEffect } from 'react';
import { Container, Button, Row, Col } from 'reactstrap';
import CompanyLayout from './CompanyLayout.jsx';
import CompanyCard from './CompanyCard.jsx';
import axios from 'axios';
import { COMPANY_URL, REQUEST_HEADERS, PAGE_SIZE } from '../../constants.js';



const CompaniesSearchHome = () => {
  const [searchState, setSearchState] = useState({
    isFetchingSearch: false,
    isLoading: false,
    lastKey: '',
    searchText: null,
    companiesData: [],
  });
  const [isBottom, setIsBottom] = useState(true);
  const [isLoading, setIsLoading] = useState(false);

  const search = () => {
    setSearchState({
      ...searchState,
      isFetchingSearch: true,
      lastKey: '',
      companiesData: []
    });
  }

  const handleScroll = () => {
    const scrollTop = (document.documentElement
      && document.documentElement.scrollTop)
      || document.body.scrollTop;
    const scrollHeight = (document.documentElement
      && document.documentElement.scrollHeight)
      || document.body.scrollHeight;
    if (scrollTop + window.innerHeight + 50 >= scrollHeight) {
      setIsBottom(true);
    }
  }

  useEffect(() => {
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    const {
      isFetchingSearch,
      lastKey,
      searchText,
      companiesData
    } = searchState;

    const cleanUpStates = () => {
      setSearchState(
        {
          ...searchState,
          'isFetchingSearch': false,
        },
      );
      setIsBottom(false);
      setIsLoading(false);
    }

    if ((isFetchingSearch || isBottom) && !isLoading && lastKey != null) {
      setIsLoading(true);
      axios.get(
        COMPANY_URL,
        {
          params: {
            pageSize: PAGE_SIZE,
            'lastKey': lastKey === '' ? null : lastKey,
            name: searchText,
          },
          headers: REQUEST_HEADERS,
        })
        .then(res => {
          const items = res?.data?.items ?? [];
          setSearchState(
            { ...searchState,
              'companiesData': [...companiesData, ...items],
              'lastKey': res?.data?.lastKey?.uuid,
              'isFetchingSearch': false,
            }
          );
          setIsBottom(false);
          setIsLoading(false);
        }).catch(() => {
          cleanUpStates();
        });
    }
  }, [searchState, isBottom, isLoading]);

  return (
    <Container>
      <CompanyLayout
        searchText={searchState.searchText}
        updateSearchText={
          (value) => setSearchState({...searchState, searchText: value})
        }
        onClickSearch={search} />
      <Container className="main-container">
        {searchState.companiesData.map((company, index) =>
          <CompanyCard
            data={company}
            showOpenInNewTab={true}
            renderCollapsed={true}
            key={'company_item_' + index} />
        )}
        {
          searchState.lastKey != null && !searchState.isLoading
            ? <LoadMoreButton onClick={() => setIsBottom(true)} />
            : null
        }
      </Container>
    </Container>
  );
}

const LoadMoreButton = (props) => {
  const { onClick } = props;
  return (
    <Row>
      <Col sm={{ offset: 5, size: 2 }}>
        <Button color="link" onClick={onClick}>
          Cargar Más Empresas
        </Button>
      </Col>
    </Row>
  );
}

export default CompaniesSearchHome;
